import UNKNOWN_LOCK_IMAGE from "../../public/devices/unknown-lock.png"

export { UNKNOWN_LOCK_IMAGE }
